import axios from '@/api/axios'
import {omit} from 'ramda'

const registrationSendSmsCode = (state) => {
  return axios
    .post('/registration/sendSmsCode', {state})
    .then((response) => response.data)
}

const registrationCheckSmsCode = (data) => {
  return axios
    .post('/registration/checkSmsCode', data)
    .then((response) => response.data)
}

const registrationBankAuthorization = (state) => {
  return axios
    .get('/registration/bankAuthorization', {params: {state}})
    .then((response) => response.data)
}

const registration = (state) => {
  return axios
    .get('/registration', {params: {state}})
    .then((response) => response.data)
}

const registrationUserPhone = (phone) => {
  return axios
    .post('/registration/user/phone', {phone})
    .then((response) => response.data)
}

const registrationAdminPhone = (phone) => {
  return axios
    .post('/registration/admin/phone', {phone})
    .then((response) => response.data)
}

const registrationUserPassword = (dataInput) => {
  const data = omit(['type'], dataInput)
  const type = dataInput.type
  return axios
    .post(`/registration/${type}/password`, data)
    .then((response) => response.data)
}

const registrationUserChangeData = (data) => {
  return axios
    .post('/registration/user/changeData', data)
    .then((response) => response.data)
}

export default {
  registrationSendSmsCode,
  registrationAdminPhone,
  registration,
  registrationCheckSmsCode,
  registrationBankAuthorization,
  registrationUserPhone,
  registrationUserPassword,
  registrationUserChangeData,
}
